import React, { useState, useEffect } from 'react';

import './index.css';

import ProfessionalMembers from './member';
import ConferenceChair from './conference';
import ProgramComittee from './program';
import JournalReviewer from './journal-reviewer';
import ConferenceReviewer from './conference-reviewer';
import TPCChair from './tpc-chair';

const Component = () => {
    const URL = `${process.env.PUBLIC_URL}/_data/home/professional-activities.json`;

    const [content, setContent] = useState({
        MemberOfProfessionalBodies: [],
        ConferenceSessionChair: [],
        TPCChair: [],
        TPCMember: [],
        // ProgramCommitteeMember: [],
        JournalReviewer: [],
        ConferenceReviewer: []
    });

    useEffect(() => {
        // GET QuickLinks
        fetch(URL)
            .then((res) => res.json())
            .then((reply) => {
                setContent(reply);
            });
    }, []);

    return (
        <div id="ProfessionalActivities" className="professional-activities">
            <h3>Professional Activities</h3>
            <ProfessionalMembers items={content.MemberOfProfessionalBodies} />
            <ConferenceChair items={content.ConferenceSessionChair} />
            <TPCChair items={content.TPCChair} />
            {/* TPCMember formerly ProgramComittee or ProgramCommitteeMember */}
            <ProgramComittee items={content.TPCMember} />
            <JournalReviewer items={content.JournalReviewer} />
            <ConferenceReviewer items={content.ConferenceReviewer} />
        </div>
    );
};

export default Component;
